import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Memoriam = () => {
    const { t } = useTranslation();

    const items = [
        {
            id: "lizi",
            src: "/img/lizi.jpg",
            texts: [t("memoriam.text-1")]
            // footer: t("memoriam.text-3"),
        },
        {
            id: "reno",
            src: "/img/reno.jpg",
            texts: [t("memoriam.text-4")],
            // footer: t("memoriam.text-6"),
        },
    ];

    return (
        <div className="container py-5">
            <div className="row g-4 align-items-stretch row-cols-1 row-cols-md-2">
                {items.map(({ id, src, texts, footer }) => (
                    <div key={id} className="col d-flex">
                        <Card className="shadow-sm h-100 d-flex flex-column overflow-hidden rounded-3">
                            {/* Responsive image wrapper */}
                            <div className="w-100 bg-body-secondary" style={{ maxHeight: "500px", overflow: "hidden" }}>
                                <img
                                    src={src}
                                    alt={id}
                                    className="w-100 h-auto"
                                    style={{
                                        objectFit: "contain", 
                                        maxHeight: "500px",  
                                    }}
                                    loading="lazy"
                                />
                            </div>

                            {/* Card body */}
                            <Card.Body className="d-flex flex-column px-3 px-md-4">
                                {texts.map((p, i) => (
                                    <p key={i} className="lh-base mb-2">
                                        {p}
                                    </p>
                                ))}
                                {footer && (
                                    <div className="mt-auto small text-muted">{footer}</div>
                                )}
                            </Card.Body>
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Memoriam;
